import React from 'react';

import IndicatorPill from 'components/IndicatorPill';
import USERS from 'constants/users';
import {
    isMultipleClientAdminFeatureEnabled,
    isParentPartnerAdminFeatureEnabled,
} from 'utils/company';
import { isClientAdminOnlyRole } from 'utils/user';

const PILL_STYLE = { marginRight: '70px' };

export const PPAPillComponent = () => (
    <IndicatorPill
        title={USERS.MULTIPLE_COMPANY_MANAGEMENT.PARENT_PARTNER_ADMIN_PILL}
        style={PILL_STYLE}
    />
);

export const MCAPillComponent = () => (
    <IndicatorPill
        title={USERS.MULTIPLE_CLIENT_ADMIN.MULTIPLE_CLIENT_ADMIN_PILL}
        width="205px"
        style={PILL_STYLE}
    />
);

/**
 * Checks if PPA (Parent Partner Admin) indicator should be enabled.
 *
 * @param {string} role - The user's role
 * @param {boolean} isParent - Whether the user is a parent admin
 * @return {boolean}
 */
export const checkIsPPAEnabled = (role, isParent) =>
    isParentPartnerAdminFeatureEnabled() &&
    role === USERS.MULTIPLE_COMPANY_MANAGEMENT.PARTNER_ADMIN &&
    !!isParent;

/**
 * Checks if MCA (Multiple Client Admin) indicator should be enabled.
 *
 * @param {string} role - The user's role
 * @param {boolean} isParent - Whether the user is a parent admin
 * @return {boolean}
 */
export const checkIsMCAEnabled = (role, isParent) =>
    isMultipleClientAdminFeatureEnabled() && isClientAdminOnlyRole(role) && !!isParent;

/**
 * Returns the appropriate pill component based on PPA/MCA state.
 * PPA takes priority over MCA when both are enabled.
 *
 * @param {boolean} isPPAEnabled - Whether PPA pill should be shown
 * @param {boolean} isMCAEnabled - Whether MCA pill should be shown
 * @return {Function|null} The pill component or null
 */
export const getIndicatorPillComponent = (isPPAEnabled, isMCAEnabled) => {
    if (isPPAEnabled) {
        return PPAPillComponent;
    }
    if (isMCAEnabled) {
        return MCAPillComponent;
    }
    return null;
};
